export default __webpack_public_path__ + "static/media/Picsart_22-12-10_15-41-40-018.eb8e2bbc.jpg";